import type { FC } from 'react'

import type { WhiteLabel } from '@skytech/types'
import BellIcon from 'mdi-react/BellIcon'
import { Link } from 'react-router-dom'
import { twJoin } from 'tailwind-merge'

import { useAppContext } from '@/App.context'
import { useProfile } from '@/hooks/useProfile'
import { APP_ROUTES } from '@/util/appRoutes'

export const NotificationBell: FC = () => {
  const { whiteLabel } = useAppContext()
  const { profile } = useProfile()
  const notificationCount = formatNotificationCount(profile?.activitiesCount || 0)
  const iconColor = iconColorByWhiteLabel[whiteLabel] || iconColorByWhiteLabel.skytech

  return (
    <>
      {Boolean(profile && profile.activitiesCount > 0) && (
        <Link
          to={APP_ROUTES.activities}
          className="relative ml-1 flex items-center justify-center text-white sm:ml-0.5 lg:hidden"
        >
          <BellIcon className={twJoin(iconColor, 'size-6 sm:size-8')} />
          <div
            className={twJoin(
              'absolute -top-1 left-3 mx-0.5 flex h-4 w-auto items-center justify-center rounded-full px-1 text-xs text-white sm:left-4',
              whiteLabel === 'threeStepIT'
                ? 'bg-threeStepIT-failure'
                : whiteLabel === 'telia'
                  ? 'bg-telia-red'
                  : 'bg-red'
            )}
          >
            {notificationCount}
          </div>
        </Link>
      )}
    </>
  )
}

const iconColorByWhiteLabel: Partial<Record<WhiteLabel, string>> = {
  skytech: 'text-white',
  bechtle: 'text-[#171717]',
  elkjop: 'text-[#171717]',
  telia: 'text-[#171717]',
  threeStepIT: 'text-threeStepIT-seaMistPrimary',
  mobit: 'text-mobit',
  csi: 'text-csi-maroon',
}

export const formatNotificationCount = (count: number) => {
  if (Math.abs(count) >= 1000000) {
    return '1M+'
  }
  if (Math.abs(count) >= 1000) {
    return '1K+'
  }
  if (count > 99) {
    return '99+'
  }
  return count.toString()
}
